import { render, staticRenderFns } from "./reset-password.vue?vue&type=template&id=247d0b2a&scoped=true&"
import script from "./reset-password.vue?vue&type=script&lang=js&"
export * from "./reset-password.vue?vue&type=script&lang=js&"
import style0 from "./reset-password.vue?vue&type=style&index=0&id=247d0b2a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247d0b2a",
  null
  
)

component.options.__file = "reset-password.vue"
export default component.exports